/* eslint-disable react/no-array-index-key */
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as SummaryState from '../../../state/reducer/summary/summary';
import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import SessionHeader from './SessionHeader';
import Block from './Block';
import SummaryHeader from './SummaryHeader';
import AddedBlock from '../../../v5/addedBlocks/components/AddedBlock';

import Console from '../../../lib/debug';

type Props = {
    session: {
        id: number,
        key: number,
        title: string,
        workout_id: number,
        fake?: boolean,
        instruction: string,
        icon: string,
        logo: string,
        workoutSets: Array<WorkoutSetTyping>,
        setKeys: Array<number>,
        published: number
    },
    isHoverPreview: () => void,
    fromDrawer: boolean,
    sessionOverlayOpen: boolean,
    programId: string | number,
    programType: number,
    isPreview: boolean,
    currentUserId: number | string
};

class Session extends Component<Props> {
    dayKey: string;
    weekIndex: number;

    showFeedDrawer(e: Event) {
        e.preventDefault();
        CalendarState.toggleBasicDrawer();
        SummaryState.getAthleteSummaryForProgramWorkout(
            this.props.session.workout_id,
            this.props.currentUserId,
            this.props.session
        );
    }

    render() {
        Console.render('Session');
        let session = this.props.session || this.props.sessionUpdated;
        let isPreview = this.props.isPreview;
        let programType = this.props.programType;
        let programId = this.props.programId;
        let blocks = [];
        let addedBlocks = [];
        let body = null;
        let weekIndex = this.weekIndex;
        let dayKey = this.dayKey;
        let sessionOverlayOpen = this.props.sessionOverlayOpen;

        if (session.setKeys) {
            for (let i = 0; i < session.setKeys.length; i++) {
                let setKey = session.setKeys[i];
                let isLast = session.setKeys.length - 1 === i ? true : false;
                let block = (
                    <Block
                        key={'block' + i}
                        last={isLast}
                        session={session}
                        setKey={setKey}
                        isPreview={isPreview}
                        programType={programType}
                        programId={programId}
                    />
                );
                blocks.push(block);
            }
        }
        // This is used for the <Preview /> component
        else {
            for (let i = 0; i < session.workoutSets.length; i++) {
                let isLast =
                    session.workoutSets.length - 1 === i ? true : false;
                let block = (
                    <Block
                        key={'block' + i}
                        last={isLast}
                        session={session}
                        set={session.workoutSets[i]}
                        isPreview={isPreview}
                        programType={programType}
                    />
                );
                blocks.push(block);
            }
        }

        const addedSets = this.props.summarySession
            ? this.props.summarySession.addedSets
            : null;

        if (addedSets) {
            addedSets.forEach((setId: number, i: number) => {
                const isLast = addedSets.length - 1 === i ? true : false;

                const block = (
                    <AddedBlock
                        key={`block${i}`}
                        last={isLast}
                        session={session}
                        setKey={setId}
                        isPreview={isPreview}
                        programType={programType}
                        programId={programId}
                    />
                );
                addedBlocks.push(block);
            });
        }

        let logo = null;
        if (session.logo || session.icon) {
            logo = (
                <div className="session-logo">
                    <img alt="" src={session.logo || session.icon} />{' '}
                </div>
            );
        }

        let instruction = null;
        if (
            this.props.calendarInstructionsEnabled &&
            session.instruction &&
            session.instruction.length > 0
        ) {
            instruction = !/^\s+$/g.test(session.instruction) ? (
                <pre className="description-toggle">{session.instruction}</pre>
            ) : null;
        }
        const isProgram = ProgramTypes.isProgram(programType);

        if (isPreview && !session.fake) {
            let classes = 'session-preview';
            if (this.props.fromDrawer) {
                classes = 'session-preview to-hide';
            }

            let summaryHeader = null;
            if (!isProgram && !this.props.fromDrawer) {
                summaryHeader = (
                    <SummaryHeader session={session} isPreview={isPreview} />
                );
            }

            body = (
                <div className={classes}>
                    <SessionHeader
                        session={session}
                        weekIndex={weekIndex}
                        dayKey={dayKey}
                        isPreview={isPreview}
                    />
                    {instruction}
                    {summaryHeader}
                    <ol className="set-list">{blocks}</ol>
                    {addedBlocks.length > 0 && (
                        <div className="added-title-container">
                            <span className="added-title">Added Exercises</span>
                        </div>
                    )}
                    <ol className="set-list">{addedBlocks}</ol>
                </div>
            );
        } else {
            let summaryHeader = null;
            if (!isProgram && !this.props.fromDrawer) {
                summaryHeader = (
                    <SummaryHeader session={session} isPreview={isPreview} />
                );
            }
            body = (
                <div className="session-preview">
                    <SessionHeader
                        session={session}
                        weekIndex={weekIndex}
                        dayKey={dayKey}
                        isPreview={isPreview}
                    />
                    {instruction}
                    {summaryHeader}
                    <ol className="set-list">{blocks}</ol>
                    {addedBlocks.length > 0 && (
                        <div className="added-title-container">
                            <span className="added-title">Added Exercises</span>
                        </div>
                    )}
                    <ol className="set-list">{addedBlocks}</ol>
                </div>
            );
        }

        let classes = `calendar-item-session${
            sessionOverlayOpen ? ' ui-selected ' : ' '
        }`;

        if (!this.props.isHoverPreview) {
            classes += ' selectable-cal-item';
        }

        if (session.fake) {
            classes += ' fake-day';
            body = (
                <div className="session-preview">
                    <div className="item-title-area">
                        <div className="session-info">
                            <div className="title">
                                {logo}
                                <span className="program-title" />
                            </div>
                        </div>
                    </div>
                    <ol className="set-list">
                        <li className="fake-block">
                            <div className="fake-circle" />
                            <ol className="ex-list">
                                <li className="fake-ex" />
                                <li className="fake-ex" />
                            </ol>
                        </li>
                        <li className="fake-block">
                            <div className="fake-circle" />
                            <ol className="ex-list">
                                <li className="fake-ex" />
                                <li className="fake-ex" />
                            </ol>
                        </li>
                        <li className="fake-block">
                            <div className="fake-circle" />
                            <ol className="ex-list">
                                <li className="fake-ex" />
                                <li className="fake-ex" />
                            </ol>
                        </li>
                    </ol>
                </div>
            );
        }

        classes += ' r-calendar-session';

        return (
            <li className={classes} id={session.workout_id}>
                {body}
            </li>
        );
    }
}

const mapStateToProps = (
    state: {
        clipboard: {
            selectedSessions: Array<SessionTyping>
        },
        calendar: {
            uiTree: {
                calendarInstructionsToggled: boolean,
                currentUser: number | string
            },
            infoTree: {
                programType: number | string
            }
        }
    },
    ownProps: {
        key: number,
        session: SessionTyping,
        isPubEnabled: boolean,
        isPreview: boolean,
        programType: number,
        fromDrawer: boolean
    }
): {
    key: number,
    session: SessionTyping,
    isPubEnabled: boolean,
    isPreview: boolean,
    programType: number | string,
    fromDrawer: boolean,
    sessionOverlayOpen: boolean,
    calendarInstructionsToggled: boolean,
    currentUserId: number | string
} => {
    let sessionOverlayOpen = _.any(
        state.clipboard.selectedSessions,
        (session: { data: SessionTyping }): boolean =>
            parseInt(session.data.id) === parseInt(ownProps.session.id)
    );

    let summary = null;
    let summarySession = null;
    if (ownProps.session) {
        summary = state.summary.summaryTree[ownProps.session.workout_id];
        summarySession =
            state.summary.calendarSummarySessionTree[
                ownProps.session.workout_id
            ];
    }
    return {
        ...ownProps,
        summary,
        summarySession,
        sessionOverlayOpen,
        calendarInstructionsEnabled:
            state.calendar.uiTree.calendarInstructionsEnabled,
        currentUserId: state.calendar.uiTree.currentUser,
        programType: state.calendar.infoTree.programType
    };
};

export default connect(mapStateToProps)(Session);



// WEBPACK FOOTER //
// ./src/view/calendar/components/Session.jsx